import { render } from "./marketsView.vue?vue&type=template&id=234b37e7"
import script from "./marketsView.vue?vue&type=script&lang=js"
export * from "./marketsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__